// Outbound links used by both the hero and the footer. Keep them here so a URL
// is filled in once rather than drifting between the two.

export const EMAIL_URL = 'mailto:akenenna@gmail.com';
export const LINKEDIN_URL = 'https://www.linkedin.com/in/kene-anyaegbunam/';
export const MEDIUM_URL = 'https://medium.com/@_Kenenna';
export const RESUME_URL = '/images/Kenenna_Anyaegbunam_Resume.pdf';
export const DEVELOPER_URL = 'https://sarah-adewale.netlify.app/';

export const BOOK_A_CALL_URL = 'https://calendly.com/akenenna/30min';

// Nutch waitlist signups are emailed to Kene by FormSubmit (formsubmit.co).
// The very first submission sends Kene a one-time "activate this form" email;
// signups are delivered once he clicks it. FormSubmit can then give a random
// alias to use here in place of the address, which hides it from the code.
export const WAITLIST_FORM_ENDPOINT = 'https://formsubmit.co/ajax/akenenna@gmail.com';
